import React, {memo} from 'react';
import {FormattedMessage} from 'react-intl';

import {URL_PRIVACY_POLICY} from '../constants';

import style from './footer.module.scss';
import Link from './link';

export default memo(
	function Footer() {
		return (
			<footer className={style.base}>
				<ul className={style.navList}>
					{
						[
							['nav.home', '/'],
							['nav.press', '/press'],
							['nav.contact', '/contact'],
							['nav.imprint', '/imprint'],
							['nav.privacyPolicy', URL_PRIVACY_POLICY],
						].map(([title, target]) => (
							<li
								key={target}
								className={style.navItem}
							>
								<Link
									href={target}
									className={style.navItemLink}
								>
									<FormattedMessage id={title} />
								</Link>
							</li>
						))
					}
				</ul>
			</footer>
		);
	}
);
